export default __webpack_public_path__ + "static/media/WStore_PromoPerks.addad42a.png";